import axios from "axios";

export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
console.log(process.env.NODE_ENV);
export default axios.create({
    baseURL: BASE_URL,
    headers: { "Access-Control-Allow-Origin": '*' }
});

export const axiosPrivate = axios.create({
    baseURL: BASE_URL
});